import React, { useState, useEffect } from "react";
import SummaryCard from "../../../../app/components/SummaryCard";
import { FiFileText, FiCheck, FiAlertOctagon, FiCheckCircle } from "react-icons/fi";
import Templates from "./tabs/Templates";
import Sent from "./tabs/Sent";
import Read from "./tabs/Read";
import { Tabs } from "../../../../app/components/Tabs";
import Errors from "./tabs/Errors";
import { usePageTitle } from '../../../../contexts/PageTitleContext';


const Emails = () => {
  const { setTitle } = usePageTitle();
              
  useEffect(() => {
    setTitle('Emails');
  }, [setTitle]);

  const [activeTab, setActiveTab] = useState("Templates");
  const [templatesCount, setTemplatesCount] = useState(0);
  const [sentCount, setSentCount] = useState(0);
  const [readCount, setReadCount] = useState(0);
  const [errorsCount, setErrorsCount] = useState(0);


  const tabs = ["Templates", "Enviados", "Leituras", "Erros"];

  const tabComponents = {
    Templates: <Templates setCount={setTemplatesCount}/>,
    Enviados: <Sent setCount={setSentCount}/>,
    Leituras: <Read setCount={setReadCount}/>,
    Erros: <Errors setCount={setErrorsCount}/>,
  };

  return (
    <div>
      <h1>Gestão completa de E-mails</h1>

      <div className="grid grid-cols-4 gap-4 mt-8">
        <SummaryCard title="Templates" value={templatesCount} icon={FiFileText} />
        <SummaryCard title="Enviados" value={sentCount} icon={FiCheck} color="#34D399" />
        <SummaryCard title="Lidos" value={readCount} icon={FiCheckCircle} color="#FBBF24" />
        <SummaryCard title="Com Erro" value={errorsCount} icon={FiAlertOctagon} color="#EF4444" />
      </div>

      <div className="mt-20 mb-10">
        <Tabs
          tabsName={tabs}
          activeTabName={activeTab}
          onTabClick={setActiveTab}
          align='left'
          />
      </div>
      <div>
        {Object.entries(tabComponents).map(([tabName, component]) => (
          <div
            key={tabName}
            style={{ display: activeTab === tabName ? "block" : "none" }}
          >
            {component}
          </div>
        ))}
      </div>

    </div>
  );
};

export default Emails;